<template>
  <div class="searchable-service-list">
    <div class="header">
      <el-input
        :value="query"
        prefix-icon="el-icon-search"
        class="query-input"
        placeholder="ค้นหาบริการ/ผู้ให้บริการ"
        clearable
        @input="handleChangeQuery"
      ></el-input>
      <sc-button
        v-if="showAddAll"
        class="add-all-button"
        @click="handleClickAddAllButton"
      >{{ addAllButtonText }}</sc-button>
    </div>
    <div class="list-body">
      <div v-if="noResult" class="empty">{{ emptyText }}</div>
      <service-selector-option
        v-for="item in value"
        :key="item.id"
        v-bind="item"
        :can-select="!disabled"
        class="selected-item"
        @select="handleSelectService(item)"
      ></service-selector-option>
      <infinite-loading
        ref="infiniteLoading"
        :identifier="infiniteLoadingIdentifier"
        spinner="spiral"
        @infinite="infiniteHandler"
      >
        <span slot="no-results" />
        <span slot="no-more" />
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton";
import { Input } from "element-ui";
import InfiniteLoading from "vue-infinite-loading";
import ServiceSelectorOption from "./ServiceSelectorOption";

export default {
  components: {
    ServiceSelectorOption,
    "el-input": Input,
    ScButton,
    InfiniteLoading
  },
  props: {
    query: { type: String, default: "" },
    isLoading: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    hasMoreServices: { type: Boolean, default: false },
    showAddAll: { type: Boolean, default: false }
  },
  data() {
    return {
      infiniteLoadingIdentifier: 0
    };
  },
  computed: {
    noResult() {
      return this.value.length === 0;
    },
    emptyText() {
      return this.query ? "ไม่พบบริการที่ค้นหา" : "ไม่มีบริการ";
    },
    addAllButtonText() {
      return this.query ? "เพิ่มผลsearchทั้งหมด" : "เพิ่มทั้งหมด";
    }
  },
  methods: {
    handleClickAddAllButton() {
      this.$emit("addAll");
    },
    handleSelectService(service) {
      this.$emit("select", service);
    },
    handleChangeQuery(value) {
      this.$emit("queryChange", value);
    },
    infiniteHandler($state) {
      setTimeout(() => {
        if (this.hasMoreServices) {
          this.$emit("getMoreServices");
          $state.loaded();
        } else {
          $state.complete();
        }
      }, 1000);
    },
    resetLoading() {
      this.infiniteLoadingIdentifier += 1;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.searchable-service-list {
  position: relative;

  border: $border;
  border-radius: $border-radius;

  .el-input__inner {
    border: 0;
    border-bottom: $border;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;

    height: 43px;
    line-height: 43px;
  }

  > .list-body {
    overflow-y: auto;
    height: 500px;
  }

  > .list-body > .empty {
    padding: 20px 0;
    text-align: center;
  }

  .loading-indicator {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 43px;

    border-bottom-right-radius: $border-radius;

    background: rgba(255, 255, 255, 0.7);

    text-align: center;
    padding: $space;

    &.active {
      display: block;
    }
  }
}

.header {
  display: grid;
  grid-template-columns: 1fr auto;

  > .add-all-button {
    height: 43px;
    font-size: 0.8rem;
    color: #444;
    border: 0;
    border-radius: 0;
    border-top-right-radius: $border-radius;
    border-left: $border;
    border-bottom: $border;

    &:hover,
    &:focus {
      border-color: #dcdfe6 !important;
    }
  }
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid $primary-color;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: $primary-color transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
